import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { DesignationPostDataAPI } from '../../../../Redux/SidebarMasterSlice/DesignationSlice';
import { RegExOnlyText } from '../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../Helper/AstricSign';
import { RolePostDataAPI } from '../../../../Redux/SidebarMasterSlice/WaterSupplySidebarSlice/RoleMasterSlice';
import { useSearchParams } from 'react-router-dom';
import { ProjectTypeDataDDL } from '../../../../Components/CommonDDL/ProjectTypeDataDDL';


export default function RoleMasterPopup(props) {

    const { item, EditIcon, Flag, handleIsPost, rowData, open, handleOnCloseClick } = props

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")


    const [RoleName, setRoleName] = useState(Flag === 'Update' ? rowData.role : '')

    const [IsOpen, setIsOpen] = useState(false)

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
        Label: Flag === 'Update' ? rowData.projectType : "Select...",
    })



    const handlePost = () => {
        const data = {
            M_RoleID: Flag === 'Update' ? rowData.m_RoleID : '0',
            M_ProjectTypeID: ProjectType?.ID,
            Role: RoleName,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(RolePostDataAPI({ data }))
    }

    const [IsValidText, setIsValidText] = useState(false)
    const handleCheckText = (e) => {
        setRoleName(e.target.value)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    return (

        // <Popup
        //     onOpen={() => setIsOpen(!IsOpen)}
        //     contentStyle={{ top: '5%' }}
        //     trigger={
        //         EditIcon === 'Update' ?
        //             <i className="fa-solid fa-pen-to-square"
        //             title='Edit' style={{ cursor: 'pointer' }}
        //             >
        //             </i> :
        //             <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
        //                 style={{ color: "white", marginTop: '-2.5em' }}
        //             >
        //                 <text className="ml-2 poppins">Add</text>
        //             </i>
        //     }
        //     modal
        // >

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Role Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">
                                <div className="col-md-6 col-lg-6">
                                    <ProjectTypeDataDDL
                                        ProjectType={ProjectType}
                                        setProjectType={setProjectType}
                                        Flag={Flag}
                                        rowData={rowData}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Role Name <AstricSign /> </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="RoleName"
                                            value={RoleName}
                                            onChange={(e) => handleCheckText(e)}
                                        // onChange={(e) => setRoleName(e.target.value)}
                                        />
                                        {/* {
                                            IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                        } */}
                                    </div>
                                </div>

                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            RoleName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}